import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VrTransactionList } from "../../Redux/Actions/resellerActions"; 
import { columnsVrTransaction } from "../../Global Functions/columnsAntd"; 
import TableComponent from "../../Global Functions/tableComponentsCp";
import toast from "react-hot-toast";
import DateRangePopup from "../../Utils/dateFilterPopup";

const ListVrTransactionHistory = () => {
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });

  const { vrTransactionList, loading } = useSelector((state) => state.reseller);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const handleStatusChange = async (record, action) => {
    console.warn("handleStatusChange not implemented for VR transactions");
  };

  const fetchDetails = useCallback(
    async (page, pageSize, showLoader = true) => {
      const teamData = {
        page,
        limit: pageSize,
        is_deleted: false,
        search: debouncedSearch,
        ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
        ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
      };

      try {
        await dispatch(VrTransactionList(teamData)); 
        if (!showLoader) {
          toast.success("VR transaction list refreshed");
        }
      } catch (err) {
        if (!showLoader) {
          toast.error("Failed to refresh VR transaction list");
        }
      }
    },
    [dispatch, debouncedSearch, dateRange]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  useEffect(() => {
    if (vrTransactionList?.total) {
      setPagination((prev) => ({ ...prev, total: vrTransactionList.total }));
    }
  }, [vrTransactionList]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponent
        h3heading="VR Transaction List"
        setState={setSearchQuery}
        onCalendarClick={() => setIsDatePopupVisible(true)}
        dataSource={
          Array.isArray(vrTransactionList?.message) ? vrTransactionList.message : []
        }
        pagination={pagination}
        onChange={handleTableChange}
        loading={loading}
        columns={columnsVrTransaction(handleStatusChange)}
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListVrTransactionHistory;